const ford = {
  state: () => ({
    images: {
      sedans: [
        // Models missing images
        // {
        //   modelName: "Taurus",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Taurus-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/MISSING.png")
        // },
        // {
        //   modelName: "Fiesta",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Fiesta-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/MISSING.png")
        // },
        // {
        //   modelName: "Fusion",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Fusion-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/fusion.png"),
        //   trims: ["S", "SE", "SEL", "Titanium", "V6 Sport"]
        // },
        {
          modelName: "Mustang",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Mustang-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-mustang.png"),
          trims: ["EcoBoost", "EcoBoost Premium", "GT", "GT Premium", "Mach 1", "Mach 1 Premium", "Shelby GT500"]
        },
      ],
      suvs: [
        {
          modelName: "Bronco",
          sideView: require("../../../static/images/carcuts/ford/angle-view/bronco21.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-bronco.png"),
          trims: ["Base", "Big Bend", "Black Diamond", "Outer Banks", "Badlands", "Wildtrak"]
        },
        {
          modelName: "Bronco Sport",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-bronco-sport.png"),
          trims: ["S", "SE", "SES", "Titanium"]
        },
        {
          modelName: "Escape",
          sideView: require("../../../static/images/carcuts/ford/angle-view/escape.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-escape.png"),
          trims: ["S", "SE", "SE Sport", "SEL", "Titanium"]
        },
        {
          modelName: "Explorer",
          sideView: require("../../../static/images/carcuts/ford/angle-view/explorer.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-explorer.png"),
          trims: ["Explorer", "XLT", "Limited", "ST", "Platinum"]
        },
        // {
        //   modelName: "Edge",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Edge-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/edge.png"),
        //   trims: ["SE", "SEL", "ST-Line", "Titanium", "ST"]
        // },
        {
          modelName: "Expedition",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Expedition-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-expedition.png"),
          trims: ["XL", "XLT", "Limited", "King Ranch", "Platinum"]
        },
        {
          modelName: "Mustang Mach-E",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-mustang-e.png"),
          trims: ["Select", "Premium", "GT", "Rally"]
        },
      ],
      trucks: [
        {
          modelName: "F-150",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-F-150-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-f-150.png"),
          trims: ["XL", "XLT", "Lariat", "King Ranch", "Platinum", "Limited", "Tremor", "Raptor"]
        },
        {
          modelName: "Ranger",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Ranger-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-ranger.png"),
          trims: ["XL", "XLT", "Lariat"]
        },
        {
          modelName: "Super Duty",
          // sideView: require("../../../static/images/carcuts/ford/side-view/superduty.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-super-duty.png")
        },
        {
          modelName: "F-150 Lightning",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-f-150-lightning.png")
        },
        {
          modelName: "Maverick",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-maverick.png")
        },
        {
          modelName: "Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-e-transit.png")
        },
        {
          modelName: "E-Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-transit.png")
        }
      ],
      evs: [
        {
          modelName: "Escape Hybrid",
          // sideView: require("../../../static/images/carcuts/ford/angle-view/escape.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-escape.png"),
          // trims: ["S", "SE", "SE Sport", "SEL", "Titanium"]
        },
        {
          modelName: "Mustang Mach-E",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-mustang-e.png"),
          // trims: ["Select", "Premium", "GT", "Rally"]
        },
        {
          modelName: "Explorer Hybrid",
          sideView: require("../../../static/images/carcuts/ford/angle-view/explorer.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-explorer.png"),
          trims: ["Explorer", "XLT", "Limited", "ST", "Platinum"]
        },
        {
          modelName: "F-150 Hybrid",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-F-150-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-f-150.png"),
          trims: ["XL", "XLT", "Lariat", "King Ranch", "Platinum", "Limited", "Tremor", "Raptor"]
        },
        {
          modelName: "F-150 Lightning",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-f-150-lightning.png")
        },
        {
          modelName: "Maverick",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-maverick.png")
        },
        {
          modelName: "E-Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-transit.png")
        }
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/ford/lifestyle/explorer-21.jpg"),
        sedanImage: require("../../../static/images/carcuts/ford/lifestyle/ford-mustang.jpg"),
        suvImage: require("../../../static/images/carcuts/ford/lifestyle/edge-21.jpg"),
        truckImage: require("../../../static/images/carcuts/ford/lifestyle/f150-21.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/progressive_redirect/playback/1090164408/rendition/1080p/file.mp4?loc=external&signature=4039b064acd8ba014094e29282e981013fb52090f2ece43da5f06cc8b58ba380"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/ford-New.png"), require("../../../static/images/buttons/round-buttons/ford-Used.png"), require("../../../static/images/buttons/round-buttons/ford-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/ford-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/ford-new.png"), require("../../../static/images/buttons/browse-buttons/ford-used.png"), require("../../../static/images/buttons/browse-buttons/ford-service.png"), require("../../../static/images/buttons/browse-buttons/ford-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/ford01.png"), require("../../../static/images/buttons/swoop-icons/ford03.png"), require("../../../static/images/buttons/swoop-icons/ford02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/ford/CM-DJ-24-Ford-Established.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Lifestyle.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Modern.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Established.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Lifestyle.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Modern.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-ford.png"),
        require("../../../static/images/buttons/logos/dd-logo-ford-w.png"),
        require("../../../static/images/buttons/logos/dd-logo-ford-25.png")
      ]
    },
   colors: {
      "--primary-color": "#01095b",
      "--primary-dark": "#01142e",
      "--primary-light": "#fff",
      "--secondary-color": "#1700f4",
      "--secondary-dark": "#000",
      "--secondary-light": "#bfbfbf",
    },
    fonts: {
      "--heading-text": "FordAntenna-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "FordAntenna-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "FordAntenna-Regular, 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "FordAntenna-Bold, 'Helvetica Neue', Arial, sans-serif"
    },
    borderRadius: {
      "--brand-br": "50px"
    }
  })
}


export default ford